import React, { FC, useCallback } from 'react';
import { Box, Text } from '@mantine/core';
import { useStyles } from './styles';
import useCopyToClipboard from '../../../hooks/useCopyToClipboard';
import { useTranslation } from 'react-i18next';
import { EllipsisTooltip } from '@components/EllipsisTooltip';

interface ITextFieldProps {
  title: string;
  description?: string | null;
  link?: boolean;
  leftSection?: React.ReactNode;
}

export const TextField: FC<ITextFieldProps> = ({ title, description, link, leftSection }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();
  const { copy } = useCopyToClipboard();

  const copyText = useCallback(async () => {
    await copy(description ?? '');
  }, [description]);

  return (
    <Box className={classes.container}>
      <Text className={classes.title}>{title}</Text>
      <Box className={classes.group}>
        {leftSection ? leftSection : null}
        <Box maw={300} onClick={copyText}>
          <EllipsisTooltip
            data-text={description}
            className={cx(classes.description, {
              [classes.link]: description && link
            })}
            width={300}
          >
            {description ? description : t('noInformation')}
          </EllipsisTooltip>
        </Box>
      </Box>
    </Box>
  );
};
